var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.7563 5.25H6.36132C5.54449 5.25 4.88232 5.98873 4.88232 6.9V11.85C4.88232 12.7613 5.54449 13.5 6.36132 13.5H13.7563C14.5731 13.5 15.2353 12.7613 15.2353 11.85V6.9C15.2353 5.98873 14.5731 5.25 13.7563 5.25Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0587 10.75C10.8384 10.75 11.4705 10.1344 11.4705 9.375C11.4705 8.61561 10.8384 8 10.0587 8C9.27904 8 8.64697 8.61561 8.64697 9.375C8.64697 10.1344 9.27904 10.75 10.0587 10.75Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.2941 4.88333V4.15C13.2941 3.71239 13.1241 3.29271 12.8215 2.98327C12.519 2.67384 12.1086 2.5 11.6807 2.5H3.61345C3.18553 2.5 2.77515 2.67384 2.47257 2.98327C2.16999 3.29271 2 3.71239 2 4.15V9.09999C2 9.5376 2.16999 9.95728 2.47257 10.2667C2.77515 10.5762 3.18553 10.75 3.61345 10.75H4.28571",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0.5)"
})));
function SvgCashNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashNote);
export default __webpack_public_path__ + "static/media/cash-note.fb251bf5.svg";
export { ForwardRef as ReactComponent };